<div class="flex-1 flex flex-col gap-y-2 overflow-y-auto p-2">
<div *ngFor="let trip of trips" class="relative gap-y-2 ">
   
    <div
        class="mix-blend-multiply rounded-md ring-1 ring-main-base p-2 flex flex-col text-xs text-main-secondary bg-white dark:bg-zinc-950 shadow">
        <div class="flex items-start justify-between flex-wrap gap-1">
            <div class="flex flex-col">
                <div class="flex items-center gap-1">
                    <div class="text-sm-dark font-semibold">
                        <span>
                            {{trip.member?.firstName}} {{trip.member?.lastName}}
                        </span>
                    </div>
                    <!-- <div class="text-red-500 font-medium">{{trip.pickup?.time ? (trip.pickup?.time | timeago:live)
                                        : ''}}</div> -->
                    <div *ngIf="selectedStatus == 'alarming'" [ngClass]="isPastTime(trip.pickup?.time) ? 'text-red-500' : 'text-green-500'" class="font-medium">
                        {{ trip.pickup?.time | timeago:true }}
                    </div>
                </div>
                <div class="text-xs-light leading-none">{{trip.reference ? trip.reference : 'N/A'}}</div>
            </div>
            <div class="flex items-center gap-1">
               
                <span class="badge-success">
                    {{trip.status | titlecase}}
                </span>
                <span *ngIf="trip.company" class="badge-secondary">{{trip?.company?.name}}</span>
            </div>
        </div>
        <ul role="list" class="mt-2 space-y-2 overflow-hidden">
            <li class="relative flex gap-x-2">
                <div class="absolute -bottom-6 left-0 top-0 flex w-6 justify-center">
                    <div class="w-px bg-zinc-950/10 dark:bg-white/10"></div>
                </div>
                <div
                    class="relative flex size-6 flex-none flex-col items-center justify-center bg-white dark:bg-zinc-950">
                    <div class="size-1.5 rounded-full bg-green-500"></div>
                </div>
                <div class="py-1">
                    <p class="text-xs-dark leading-tight">{{trip?.pickup?.address?.name}}
                    </p><time class="text-xs-light leading-tight">{{trip.pickup?.time | date: 'MM/DD/YYYY HHmm'}}</time>
                </div>
            </li>
            <li class="relative flex gap-x-2">
                <div class="relative flex size-6 flex-none items-center justify-center bg-white dark:bg-zinc-950">
                    <div class="size-1.5 rounded-full bg-red-500"></div>
                </div>
                <div class="py-1">
                    <p class="text-xs-dark leading-tight">{{trip?.destination?.address?.name}}
                    </p><time class="text-xs-light leading-tight">{{trip.destination?.time | date: 'MM/DD/YYYY HHmm'}}</time>
                </div>
            </li>
        </ul>
        <div class="mt-2 flex flex-col gap-2">
            <div class="flex flex-wrap items-center gap-y-2 gap-x-6">
                <div class="flex items-center gap-x-1.5">
                    <div>
                        <svg class="h-4 w-4 text-xs-light" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01l-1.97 5.67c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S6 20.33 6 19.5V19h12v.5c0 .82.67 1.5 1.5 1.5c.82 0 1.5-.67 1.5-1.5v-7.16c0-.22-.04-.45-.11-.66l-1.97-5.67zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM5 11l1.27-3.82c.14-.4.52-.68.95-.68h9.56c.43 0 .81.28.95.68L19 11H5z" />
                        </svg>
                    </div>
                    <div class="text-xs-dark">
                        <span class="text-main-dark">
                            <span *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService]">
                                {{preLevelOfService[trip.levelOfService].title | titlecase}}
                              </span>
                        </span>
                        
                            <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType]">
                                ({{preSpacetypes[trip.spaceType].title | titlecase}})
                              </span>
                        
                    </div>
                </div>
                <div class="flex items-center gap-x-1.5">
                    <div>
                        <svg class="h-4 w-4 text-xs-light" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                                d="M511.984 36.128C230.016 36.128.639 265.536.639 547.504c0 177.152 89.68 339.185 239.903 433.408c14.944 9.472 34.688 4.88 44.097-10.096s4.88-34.72-10.096-44.095c-54.096-33.952-99.04-78.048-133.424-128.88l33.552-19.376c15.311-8.848 20.56-28.4 11.712-43.711c-8.88-15.344-28.464-20.56-43.712-11.712l-33.6 19.391c-24.4-50.511-39.297-105.792-43.281-163.424h35.616c17.68 0 32-14.32 32-32s-14.32-32-32-32H65.95c4.24-58.687 19.776-114.304 44.56-164.592l32.16 18.56a31.745 31.745 0 0 0 15.97 4.288c11.055 0 21.807-5.744 27.743-16c8.847-15.312 3.6-34.88-11.712-43.713l-31.84-18.368c32.112-46.832 72.864-87.296 119.984-119.023l18.016 31.2c5.935 10.288 16.687 16 27.743 16a31.75 31.75 0 0 0 15.969-4.288c15.311-8.848 20.56-28.4 11.712-43.712l-17.953-31.072c49.329-23.792 103.68-38.656 160.976-42.816v39.872c0 17.68 14.32 32 32 32s32-14.32 32-32v-40c58.592 4.08 114.128 19.391 164.384 43.95l-17.36 30.049c-8.848 15.311-3.6 34.88 11.712 43.712a31.745 31.745 0 0 0 15.969 4.288c11.055 0 21.807-5.712 27.743-16l17.28-29.936a451.19 451.19 0 0 1 118.88 118.816l-29.968 17.312c-15.311 8.847-20.56 28.4-11.711 43.71c5.935 10.289 16.687 16 27.743 16c5.44 0 10.944-1.375 15.969-4.287l30.127-17.392C938.638 401.839 954 457.39 958.094 516H922.96c-17.68 0-32 14.32-32 32s14.32 32 32 32h35.12c-4.048 56.88-18.592 111.439-42.496 161.312l-31.68-18.288c-15.28-8.848-34.912-3.568-43.712 11.713c-8.848 15.311-3.6 34.88 11.712 43.712L883.68 796.8c-35.103 52.24-81.44 97.393-137.359 131.824c-15.055 9.28-19.712 29.008-10.464 44.032c6.065 9.808 16.529 15.216 27.28 15.216a31.896 31.896 0 0 0 16.753-4.752c152.464-93.904 243.472-256.784 243.472-435.632c0-281.952-229.408-511.36-511.376-511.36zm236.127 411.6c15.296-8.848 20.544-28.398 11.712-43.71c-8.832-15.296-28.416-20.544-43.712-11.696L542.287 492.674c-9.28-5.248-19.856-8.496-31.28-8.496c-35.28 0-63.84 28.591-63.84 63.807c0 35.248 28.576 63.84 63.84 63.84c35.28 0 63.84-28.592 63.84-63.84c0-.064-.016-.144-.016-.209z" />
                        </svg>
                    </div>
                    <div class="text-xs-dark">{{trip.miles}} mi</div>
                </div>
                <div class="flex items-center gap-x-1.5">
                    <div>
                        <svg class="h-4 w-4 text-xs-light" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1c0 9.39 7.61 17 17 17c.55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1c-1.24 0-2.45-.2-3.57-.57a.84.84 0 0 0-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1z" />
                        </svg>
                    </div>
                    <div class="text-xs-dark" phoneNumberFormat [phoneNumber]="trip?.member?.contactNumber">
                       {{trip?.member?.contactNumber}}
                    </div>
                </div>
                <div class="flex items-center gap-x-1.5">
                    <div>
                        <svg class="h-4 w-4 text-xs-light" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <g fill="currentColor">
                                <path
                                    d="M6 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7Zm-1 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z" />
                                <path fill-rule="evenodd"
                                    d="M2 4a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V4Zm3-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"
                                    clip-rule="evenodd" />
                            </g>
                        </svg>
                    </div>
                    <div>
                        <a href="javascipt:void(0)" (click)="memberNotesObj.emit(trip)" class="text-xs-dark cursor-pointer font-semibold">
                            Notes
                        </a>
                    </div>
                </div>
                <div *ngIf="['onway','in_progress','arrived'].includes(trip.status)" class="flex items-center gap-x-1.5">
                    <div>
                        <svg class="h-4 w-4 text-xs-light" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z" />
                            <path fill="currentColor"
                                d="M19 14c-1.654 0-3 1.346-3 3c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z" />
                        </svg>
                    </div>
                    <div>
                        <a href="javascript:void(0)" class="text-xs-dark" (click)="checkETA(trip)">Fetch ETA</a>
                        <span class="text-xs-dark ">{{ trip.etaTime ? ': '+trip.etaTime: '' }}</span>
                    </div>
                </div>
              
                <div class="flex items-center gap-x-1.5 col-span-1">
                    <div>
                        <svg class="h-4 w-4 text-xs-light" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z" />
                            <path fill="currentColor"
                                d="M19 14c-1.654 0-3 1.346-3 3c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z" />
                        </svg>
                    </div>
                    <div>
                        <a class="text-xs-dark font-semibold cursor-pointer" (click)="checkLoaded(trip)">Loaded Time</a>
                        <span>{{ trip.loadedMiles ? ': '+trip.loadedMiles: '' }}</span>
                    </div>
                </div>

                <div *ngIf="trip.tempDriver" class="flex items-center gap-x-1.5 col-span-1">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 text-xs-light fill-current" viewBox="0 0 24 24">
                            <path fill="none" stroke="currentColor" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="2"
                                d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0M6 21v-2a4 4 0 0 1 4-4h3m8 0h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H17m2 0v1m0-8v1" />
                        </svg>
                    </div>
                    <div  class="text-xs-dark font-medium">
                        {{trip?.tempDriver?.firstName}} {{trip?.tempDriver?.lastName}}
                    </div>
                </div>
              
            </div>
        </div>
    <div class="flex mt-2 justify-end"><button (click)="tripDetails.emit(trip)" class="btn btn-secondary text-xs px-2 py-1">Details</button></div>
    </div>
</div>
</div>